import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectProductAPL = (state) => state.productAPL || initialState;

const selectProductAPLColumns = () =>
  createSelector(selectProductAPL, (aplState) => aplState.productAplColumns);

const makeSelectReloadGridApl = () =>
  createSelector(selectProductAPL, (aplState) => aplState.reloadGrid);

export { selectProductAPLColumns, makeSelectReloadGridApl };
